import { MsgHandler } from './../../core/app/msg/msgHandler';
import * as consts from './../../core/app/common/consts';
import * as units from '../../core/app/common/units';
import { AppConfig } from '../../core/app/app.config';
import { BehaviorSubject } from 'rxjs';
import { userSettings } from '../../core/app/common/settings';
import { mainMapMngr } from '@core_n/asp/MapMngr';
import { aspMngr } from '@core_n/asp/AspMngr';


export class PlaybackHandler extends MsgHandler {
    private static _self: PlaybackHandler | null = null;
    private timeIncrement: number = 1000;
    private intervalTime: number = 1000;
    private intervalId: any;

  private constructor() {
    super(consts.MSG_TYPE_PLAYBACK);

        this.startInterval();
    }

  public static getSelf(): PlaybackHandler {
    if (this._self == null)
      this._self = new PlaybackHandler();
    return this._self;
  }

    handleMsg(msgObj: any): void {
        if (AppConfig.settings.ShowLogs)
            console.log("playback msg:", msgObj);
        
            // PlaybackStart: 0 = start, 1 = stop
        if (!msgObj.PlayBackStart) {         
            userSettings.isPlayback.next(true);
            aspMngr.deleteAllObjects();
            mainMapMngr.clearObjects();
        }else {
            userSettings.isPlayback.next(false);
            if(msgObj.options){
                // find the current instance of the window by using the new service...
                    // service:
                    // duplicate angular track service... to open and manage windows from everywhere
                    // in this service make sure only one instance of the window can exist..
                // send the options array to the window to display...
                // make a new function in the Playback Mode window to accept array of options to display...
            }
        }
    }

    public promoteTime():void {
        if (userSettings.isPlayback.value) {
            userSettings.playbackTime.next(new Date(userSettings.playbackTime.value.getTime() + this.timeIncrement));
        }
    }

    //Start the Interval using the current intervalTime
    private startInterval():void {
        this.intervalId = setInterval(()=> {
            this.promoteTime();
        }, this.intervalTime);
    }

    // Clear and restart Interval
    private restartInterval(): void {
        clearInterval(this.intervalId);
        this.startInterval();
    }

    // Adjust the time increment
    public setPlaybackSpeed(speedMultiplier: number): void {
        this.timeIncrement = speedMultiplier * 1000;
        this.restartInterval();
    }

    // Reset speed to 1 second
    resetPlaybackSpeed(): void{
        this.timeIncrement = 1000;
        this.restartInterval();
    }

    // Jump Forward or backword
    public jumpTime(jump: number): void{
        userSettings.playbackTime.next(
            new Date(userSettings.playbackTime.value.getTime() + (jump*1000))
        );
    }
}
